import React from "react";
import { Form, Radio, Typography } from "../../../../../../shared/frontend/ui";
import { useI18n } from "../../app/i18n/useI18n";
import { ThemedModal } from "../../components/ThemedModal";

export type BankOrderResolveOption<T extends string | number> = { value: T; label: string };

/**
 * Klärung eines Bankauftrags von Hand, nachdem im Onlinebanking nachgesehen wurde. Gemeinsam für
 * Lastschriftlauf und Überweisungen; welche Antworten zulässig sind, entscheidet der Aufrufer.
 */
export function BankOrderResolveModal<T extends string | number>({ open, title, options, onCancel, onResolve }: {
  open: boolean;
  title: string;
  options: BankOrderResolveOption<T>[];
  onCancel: () => void;
  onResolve: (value: T) => Promise<void>;
}) {
  const { text } = useI18n();
  const [form] = Form.useForm<{ resolution: T }>();
  const [saving, setSaving] = React.useState(false);
  const finish = async (values: { resolution: T }) => {
    setSaving(true);
    try { await onResolve(values.resolution); form.resetFields(); }
    finally { setSaving(false); }
  };
  return <ThemedModal title={title} open={open} onCancel={() => { form.resetFields(); onCancel(); }} formId="bank-order-resolve"
    submitting={saving} okText={text("Confirm")} destroyOnHidden>
    <Form id="bank-order-resolve" form={form} layout="vertical" onFinish={(values) => finish(values)}>
      <Typography.Paragraph>{text("Banking order resolve instruction")}</Typography.Paragraph>
      <Form.Item name="resolution" rules={[{ required: true, message: text("Please select an option.") }]}>
        <Radio.Group options={options} />
      </Form.Item>
    </Form>
  </ThemedModal>;
}
